import React from 'react'
import { BooleanInput, required } from 'react-admin'
import { facetFilterGroupChoices, pricingFacetChoices } from 'services/cfg/form'
import { FacetCategory } from 'services/api/entities/catalog/facets'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

export type FacetFormExtension = React.FC<{ disable: boolean }>

const productFilterFields: FacetFormExtension = () => (
  <React.Fragment>
    <KSelectInput
      choices={facetFilterGroupChoices}
      source="filterGroup"
      label="form.fields.filterGroup"
      fullWidth
      validate={required()}
    />
    <LocalizedInputText
      source="filterName"
      label="form.fields.filterName"
      validate={required()}
    />
    <BooleanInput source="isTag" label="form.fields.isTag" />
  </React.Fragment>
)

const tagFields: FacetFormExtension = () => (
  <LocalizedInputText
    source="tagName"
    label="form.fields.tagName"
    validate={required()}
  />
)

const pricingFields: FacetFormExtension = () => (
  <KSelectInput
    source="pricingType"
    choices={pricingFacetChoices}
    validate={required()}
  />
)

const groupFields: FacetFormExtension = () => (
  <LocalizedInputText
    source="productClusterCode"
    label="form.fields.productClusterCode"
    validate={required()}
  />
)
const FACET_FORM_MAP: Record<FacetCategory, FacetFormExtension> = {
  productFilter: productFilterFields,
  filterTag: productFilterFields,
  tag: tagFields,
  group: groupFields,
  pricing: pricingFields,
}

export default FACET_FORM_MAP
